/**
 * Mobil Mega Menü - JavaScript
 * Tüm kategorileri ve alt kategorileri tek seferde gösterir.
 * iOS Safari uyumlu scroll kilidi içerir.
 */
(function () {
  'use strict';

  var OVERLAY_ID   = 'MobileMegaMenu';
  var TOGGLE_ID    = 'MobileMenuToggle';
  var CLOSE_ID     = 'MobileMegaMenuClose';
  var BACKDROP_ID  = 'MobileMegaMenuBackdrop';
  var OPEN_CLASS   = 'is-open';
  var LOCK_CLASS   = 'mmm-scroll-locked';

  var overlay  = null;
  var scrollY  = 0;

  /* ---------- Başlatma ---------- */
  function init() {
    overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;

    var toggle   = document.getElementById(TOGGLE_ID);
    var closeBtn = document.getElementById(CLOSE_ID);
    var backdrop = document.getElementById(BACKDROP_ID);

    if (toggle)   toggle.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (backdrop) backdrop.addEventListener('click', closeMenu);

    /* ESC tuşu ile kapat */
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && isOpen()) {
        closeMenu();
      }
    });

    /* Ana kategori başlıklarına tıklayınca alt menüyü aç/kapat */
    initCategoryToggles();

    /* Seviye-2 başlıklarına tıklayınca Seviye-3'ü aç/kapat */
    initSubToggles();
  }

  /* ---------- Seviye-1 accordion (Ana kategoriler) ---------- */
  function initCategoryToggles() {
    var titles = overlay.querySelectorAll('button.mmm-category__title');
    for (var i = 0; i < titles.length; i++) {
      titles[i].addEventListener('click', function () {
        var cat = this.parentElement; /* .mmm-category */
        var expanded = cat.classList.toggle('is-expanded');
        this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }
  }

  /* ---------- Seviye-2 accordion (Alt kategoriler → Seviye-3) ---------- */
  function initSubToggles() {
    var toggles = overlay.querySelectorAll('.mmm-subcategory__toggle');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', function () {
        var item = this.parentElement; /* .mmm-subcategory__item */
        var expanded = item.classList.toggle('is-expanded');
        this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }
  }

  /* ---------- Yardımcılar ---------- */
  function isOpen() {
    return overlay && overlay.classList.contains(OPEN_CLASS);
  }

  /* ---------- Aç ---------- */
  function openMenu() {
    if (!overlay || isOpen()) return;

    /* Mevcut scroll pozisyonunu kaydet (iOS Safari için) */
    scrollY = window.pageYOffset || document.documentElement.scrollTop;

    /* Body scroll kilidi */
    document.body.style.top = '-' + scrollY + 'px';
    document.body.classList.add(LOCK_CLASS);

    /* Overlay'i göster */
    overlay.classList.add(OPEN_CLASS);
    overlay.setAttribute('aria-hidden', 'false');

    /* Hamburger butonunu güncelle */
    var toggle = document.getElementById(TOGGLE_ID);
    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    /* Animasyon bittikten sonra kapat butonuna odaklan (erişilebilirlik) */
    var closeBtn = document.getElementById(CLOSE_ID);
    if (closeBtn) {
      setTimeout(function () { closeBtn.focus(); }, 350);
    }
  }

  /* ---------- Kapat ---------- */
  function closeMenu() {
    if (!overlay || !isOpen()) return;

    /* Overlay'i gizle */
    overlay.classList.remove(OPEN_CLASS);
    overlay.setAttribute('aria-hidden', 'true');

    /* Body scroll kilidini kaldır */
    document.body.classList.remove(LOCK_CLASS);
    document.body.style.top = '';

    /* Önceki scroll pozisyonuna geri dön */
    window.scrollTo(0, scrollY);

    /* Hamburger butonunu güncelle ve odaklan */
    var toggle = document.getElementById(TOGGLE_ID);
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
  }

  /* ---------- DOM hazır olduğunda başlat ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
